"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* Provide fade in animations when the motion.div/img etc enters into a viewable port. */
const framer_motion_1 = require("framer-motion");
const react_1 = require("react");
const react_intersection_observer_1 = require("react-intersection-observer");
const helpers_1 = require("../lib/helpers");
function useMountAnimation({ mountFadeIn }) {
    const [animated, setAnimated] = react_1.useState(false);
    const props = typeof mountFadeIn === 'string' ? {
        fadeAwayWhenHidden: false,
        onlyOnMount: true,
        initialOpacity: 0,
        key: mountFadeIn,
    } : mountFadeIn;
    const disableObserver = !mountFadeIn || animated;
    const { fadeAwayWhenHidden, initialOpacity } = props !== null && props !== void 0 ? props : {};
    const { ref: inViewRef, inView } = react_intersection_observer_1.useInView({
        skip: disableObserver,
    });
    const controls = framer_motion_1.useAnimation();
    const initiatedRef = react_1.useRef(false);
    const exitAnim = react_1.useMemo(() => ({ opacity: initialOpacity }), [initialOpacity]);
    // if we never did an animation to begin with
    // return nothing, do not check if disableObserver exists
    // as we still need to provide the ref to stop the observer
    if (!mountFadeIn || helpers_1.alreadyMountAnimated(props.key)) {
        return {};
    }
    const enterAnim = { opacity: 1, transition: { delay: 0.01 } };
    if (inView && !initiatedRef.current) {
        initiatedRef.current = true;
        controls.set(exitAnim);
    }
    if (fadeAwayWhenHidden && !inView) {
        /* set since its not visible anyways. */
        controls.set(exitAnim);
    }
    else if (inView) {
        controls.start(enterAnim)
            .then(() => {
            setAnimated(true);
            helpers_1.flagMountAnimated(props.key);
        })
            .catch(console.error);
    }
    return {
        animate: controls,
        initial: exitAnim,
        ref: inViewRef,
    };
}
exports.default = useMountAnimation;
